const fromPercentageToFraction = (value) => value / 100;

export default fromPercentageToFraction;
